import { type ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledLabel } from "./Form.styles";
import type { FormLabelProps } from "./Form.types";

const FormLabelComponent = ({
  children,
  className,
  required,
  ...rest
}: FormLabelProps): ReactElement => {
  return (
    <StyledLabel
      className={cx(className, Boolean(required) && "is-required")}
      {...rest}
    >
      {children}
    </StyledLabel>
  );
};

export const FormLabel = styled(FormLabelComponent)``;
